"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEmojiPickerStyles = void 0;
var _react = require("react");
var useEmojiPickerStyles = function useEmojiPickerStyles(showing) {
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (showing) {
      setTimeout(function () {
        var _ref$current;
        var root = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("em-emoji-picker").shadowRoot;
        var style = document.createElement("style");
        style.textContent = "\n          #root {\n            --em-rgb-color: var(--hms-ui-colors-textPrimary);\n            --color-b: var(--hms-ui-colors-textPrimary);\n            --rgb-background: transparent;\n            color: var(--hms-ui-colors-textPrimary);\n            font-family: var(--hms-ui-fonts-sans);\n          }\n          .sticky {\n            background-color: var(--hms-ui-colors-surfaceLight);\n          }\n        ";
        root.appendChild(style);
      }, 0);
    }
  }, [showing]);
  return ref;
};
exports.useEmojiPickerStyles = useEmojiPickerStyles;